(() => {
  const form = document.querySelector('.se-filters');
  if (!form || form.dataset.ready) return;

  form.dataset.ready = 'true';
  const root = form.closest('results-list');
  const status = form.querySelector('[role=status]');
  const controls = form.querySelector('fieldset');
  const retry = form.querySelector('[data-retry]');
  const sidebar = form.querySelector('.se-filters__sidebar');
  const desktop = window.matchMedia('(min-width: 750px)');
  sidebar.open = desktop.matches;
  desktop.addEventListener('change', event => { sidebar.open = event.matches; });
  let cards = [];
  let grid;
  let initialCategoryApplied = false;

  const labels = {
    category: { Tops: '上衣', Bottoms: '下身', Outerwear: '外套', Accessories: '配飾' },
    subtype: { 'T-Shirts': 'T恤', 'Baby Tees': '短版修身T恤', 'Tank Tops': '背心', 'Long Sleeves': '長袖上衣', Shirts: '恤衫', Knitwear: '針織衫', Hoodies: '連帽衛衣', Jackets: '夾克', Pants: '長褲', Shorts: '短褲', Skirts: '裙', Caps: '鴨舌帽', Beanies: '冷帽' },
    colour: { Black: '黑色', White: '白色', Grey: '灰色', Blue: '藍色', Navy: '深藍色', Green: '綠色', Yellow: '黃色', Orange: '橙色', Red: '紅色', Pink: '粉紅色', Purple: '紫色', Brown: '啡色', Tan: '淺啡色', Teal: '藍綠色', Multicolour: '多色', Cream: '奶油色', Beige: '米色' },
    size: { FREE: '均碼', 'FREE SIZE': '均碼' },
    vendor: {},
  };
  const colourMap = {
    BLACK: 'Black', WHITE: 'White', 'TRẮNG': 'White', GREY: 'Grey', GRAY: 'Grey', 'XÁM': 'Grey',
    'LIGHT GREY': 'Grey', 'DARK BLUE': 'Blue', BLUE: 'Blue', 'BLUE NAVY': 'Navy', BROWN: 'Brown',
    TAN: 'Tan', GREEN: 'Green', 'LIME GREEN': 'Green', PINK: 'Pink', RED: 'Red', YELLOW: 'Yellow',
    'WASH XÁM': 'Grey', CAMO: 'Multicolour', CARO: 'Multicolour',
  };
  const normaliseColour = value => colourMap[String(value || '').trim().toUpperCase()] || String(value || '').trim();
  const splitValues = value => String(value || '').split('|').filter(Boolean);
  const getVariants = card => {
    try { return JSON.parse(card.dataset.variants || '[]'); } catch (_) { return []; }
  };
  const getCardValues = (card, key) => {
    if (key === 'vendor') return card.dataset.vendor ? [card.dataset.vendor] : [];
    if (key === 'category') return card.dataset.type ? [card.dataset.type] : [];
    if (key === 'subtype') return card.dataset.subtype ? [card.dataset.subtype] : [];
    if (key === 'colour') return splitValues(card.dataset.colours);
    if (key === 'size') return [...new Set(getVariants(card).map(variant => variant.size).filter(Boolean))];
    return [];
  };
  const optionOrder = {
    category: ['Tops', 'Bottoms', 'Outerwear', 'Accessories'],
    subtype: ['T-Shirts', 'Baby Tees', 'Tank Tops', 'Long Sleeves', 'Shirts', 'Knitwear', 'Hoodies', 'Jackets', 'Pants', 'Shorts', 'Skirts', 'Caps', 'Beanies'],
    colour: ['Black', 'White', 'Grey', 'Blue', 'Navy', 'Green', 'Yellow', 'Orange', 'Red', 'Pink', 'Purple', 'Brown', 'Tan', 'Teal', 'Multicolour'],
    size: ['XS', 'S', 'M', 'L', 'XL', 'FREE', 'FREE SIZE'],
  };
  const sortValues = (key, values) => [...values].sort((a, b) => {
    const order = optionOrder[key];
    if (!order) return a.localeCompare(b);
    const aIndex = order.indexOf(a);
    const bIndex = order.indexOf(b);
    return (aIndex < 0 ? Number.MAX_SAFE_INTEGER : aIndex) - (bIndex < 0 ? Number.MAX_SAFE_INTEGER : bIndex) || a.localeCompare(b);
  });

  function matchesVariants(card, colours, sizes) {
    const variants = getVariants(card);
    const hasColourVariant = variants.some(variant => variant.colour);
    const matchesColour = variant => !colours.length || colours.includes(normaliseColour(variant.colour));
    const matchesSize = variant => !sizes.length || sizes.includes(variant.size);

    if (colours.length && !getCardValues(card, 'colour').some(colour => colours.includes(colour))) return false;
    if (!sizes.length && !colours.length) return true;
    if (hasColourVariant) return variants.some(variant => matchesColour(variant) && matchesSize(variant));
    return variants.some(variant => matchesSize(variant));
  }

  function matchesPrice(card, range) {
    if (range === 'all') return true;
    const [minimum, maximum] = range.split(':').map(Number);
    return Number(card.dataset.priceMin) <= maximum && Number(card.dataset.priceMax) >= minimum;
  }

  function apply() {
    const values = new FormData(form);
    const vendors = values.getAll('vendor');
    const categories = values.getAll('category');
    const subtypes = values.getAll('subtype');
    const colours = values.getAll('colour');
    const sizes = values.getAll('size');
    const price = values.get('price') || 'all';
    const active = vendors.length + categories.length + subtypes.length + colours.length + sizes.length + (price === 'all' ? 0 : 1);
    form.querySelector('[data-filter-count]').textContent = active ? `(${active})` : '';
    const found = cards.filter(card =>
      (!vendors.length || vendors.includes(card.dataset.vendor)) &&
      (!categories.length || categories.includes(card.dataset.type)) &&
      (!subtypes.length || subtypes.includes(card.dataset.subtype)) &&
      matchesVariants(card, colours, sizes) &&
      matchesPrice(card, price)
    );
    const sort = values.get('sort');
    if (sort === 'price-up') found.sort((a, b) => Number(a.dataset.priceMin) - Number(b.dataset.priceMin));
    if (sort === 'price-down') found.sort((a, b) => Number(b.dataset.priceMax) - Number(a.dataset.priceMax));
    if (sort === 'newest') found.sort((a, b) => Number(b.dataset.created) - Number(a.dataset.created));
    if (sort === 'title') found.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    grid.replaceChildren(...found);
    status.textContent = found.length ? `${found.length} 件商品` : '沒有符合篩選條件的商品';
  }

  function populateOptions(key) {
    const target = form.querySelector(`[data-options="${key}"]`);
    target.replaceChildren();
    const values = new Set(cards.flatMap(card => getCardValues(card, key)));
    for (const value of sortValues(key, values)) {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = key;
      input.value = value;
      label.append(input, document.createTextNode(labels[key][value] || value));
      target.append(label);
    }
  }

  async function load() {
    controls.disabled = true;
    form.querySelector('[name=sort]').disabled = true;
    retry.hidden = true;
    status.textContent = '正在載入篩選選項…';
    try {
      const currentUrl = new URL(location.href);
      const defaultCategory = optionOrder.category.includes(currentUrl.searchParams.get('q'))
        ? currentUrl.searchParams.get('q')
        : '';
      const url = new URL('/collections/all', location.origin);
      url.searchParams.set('section_id', form.dataset.section);
      const read = async page => {
        const pageUrl = new URL(url);
        pageUrl.searchParams.set('page', page);
        const response = await fetch(pageUrl.toString());
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = doc.querySelector('[data-testid="product-grid"]');
        if (!list) throw new Error('Collection grid unavailable');
        return list;
      };
      const existing = root.querySelector('[data-testid="product-grid"]');
      const canReuseFirst = currentUrl.pathname === '/collections/all' &&
        ![...currentUrl.searchParams.keys()].some(key => key === 'page' || key === 'sort_by' || key.startsWith('filter.'));
      const first = canReuseFirst && existing ? existing : await read(1);
      const all = [...first.querySelectorAll('li[data-product-id]')];
      const pages = await Promise.all(Array.from({ length: Math.max(0, Number(first.dataset.lastPage) - 1) }, (_, index) => read(index + 2)));
      for (const next of pages) {
        all.push(...next.querySelectorAll('li[data-product-id]'));
      }
      cards = [...new Map(all.map(card => [card.dataset.productId, card])).values()];
      grid = root.querySelector('[data-testid="product-grid"]');
      if (!grid) throw new Error('Collection grid unavailable');
      for (const key of ['vendor', 'category', 'subtype', 'colour', 'size']) populateOptions(key);
      if (defaultCategory && !initialCategoryApplied) {
        const categoryInput = [...form.querySelectorAll('[name="category"]')]
          .find(input => input.value === defaultCategory);
        if (categoryInput) categoryInput.checked = true;
        initialCategoryApplied = true;
      }
      root.querySelectorAll('#ResultsList nav').forEach(nav => { nav.hidden = true; });
      controls.disabled = false;
      form.querySelector('[name=sort]').disabled = false;
      apply();
    } catch (_) {
      status.textContent = '無法載入篩選選項，請重試。';
      retry.hidden = false;
    }
  }

  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('change', () => { if (grid) apply(); });
  form.addEventListener('reset', () => { if (grid) setTimeout(apply, 0); });
  retry.addEventListener('click', load);
  load();
})();
